import * as actionTypes from './types';
import { updateObject } from '../../utility';

const initialState = {
  columnTotal: {},
  metaData: {},
  totalArea: {},
  initialFormData: {},
  currentFormData: {},
};

const transferredManureReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TRANSFERRED_MANURE_SET_COL_TOTAL: return setColumnTotal(state, action);
    case actionTypes.TRANSFERRED_MANURE_RESET_COL_TOTAL: return resetColumnTotal(state, action);
    case actionTypes.GET_TRANSFERRED_MANURE_METADATA_SUCCESS: return setMetaDataSuccess(state, action);
    case actionTypes.GET_TRANSFERRED_MANURE_METADATA_FAIL: return setMetaDataFail(state, action);
    case actionTypes.RESET_TRANSFERRED_MANURE_METADATA: return resetMetaData(state, action);
    case actionTypes.GET_TRANSFERRED_MANURE_FORM_DATA_SUCCESS: return setFormDataSuccess(state, action);
    case actionTypes.GET_TRANSFERRED_MANURE_FORM_DATA_FAIL: return setFormDataFail(state, action);
    case actionTypes.SET_TRANSFERRED_MANURE_FORM_DATA: return setFormData(state, action);
    case actionTypes.RESET_TRANSFERRED_MANURE_ALL_DATA: return resetFormData(state, action);
    default:
      return state;
  }
};

const setColumnTotal = (state, action) => {
  const updatedState = {
    columnTotal: action.payload,
  }
  return updateObject(state, updatedState);
}

const resetColumnTotal = (state, action) => {
  const updatedState = {
    columnTotal: initialState.columnTotal,
  }
  return updateObject(state, updatedState);
}

const setMetaDataSuccess = (state, action) => {
  const updatedState = {
    metaData: action.payload,
  }
  return updateObject(state, updatedState);
}

const setMetaDataFail = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const resetMetaData = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const setFormDataSuccess = (state, action) => {
  const updatedState = {
    initialFormData: action.payload,
    currentFormData: action.payload,
  }
  return updateObject(state, updatedState);
}

const setFormDataFail = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const setFormData = (state, action) => {
  const { sectorId, formData } = action.payload;
  const updatedState = {
    currentFormData: {
      ...state.currentFormData,
      [sectorId]: {
        ...formData
      }
    },
  }
  return updateObject(state, updatedState);
}

const resetFormData = (state, action) => {
  const updatedState = {
    currentFormData: state.initialFormData,
  }
  return updateObject(state, updatedState);
}


export default transferredManureReducer;
